import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {RecommendationManagerSharedDataService} from '../recommendation-manager-shared-data.service';
import {data} from 'autoprefixer';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-leaf-recommendation',
    templateUrl: './leaf-recommendation.component.html',
    styleUrls: ['./leaf-recommendation.component.css'],
    standalone: false
})
export class LeafRecommendationComponent implements OnInit, OnDestroy {

  sampleSource: MatTableDataSource<any> = null;
  recommendationDetails: any = null;
  subscriptions: Subscription[] = [];
  pageSize: number = 20;
  currentPage: number = 0;
  totalElements: number = 0;
  searchText: string = '';
  showNorm: boolean = true;
  @Input() note: string = '';
  @Input() comment: string = '';
  @Output() noteChangeEmit = new EventEmitter();
  @Output() emitPaginateChange = new EventEmitter();
  @Output() emitSearch = new EventEmitter();

  nValues: any[] = [];
  pValues: any[] = [];
  kValues: any[] = [];
    caValues: any[] = [];
    mgValues: any[] = [];
    naValues: any[] = [];
    sValues: any[] = [];
    clValues: any[] = [];
    cuValues: any[] = [];
    znValues: any[] = [];
    mnValues: any[] = [];
    bValues: any[] = [];
    feValues: any[] = [];
    moValues: any[] = [];
  sampleColumns = [
      'bagNumber',
      'farm',
      'field',
      'sample',
      'sampleDate',
      'labReference',
      'labDate',
      'crop',
      'region',
      'growthStage',
      'cultivar',
      'blank',
      'nitrogen',
      'phosphorus',
      'potassium',
      'calcium',
      'magnesium',
      'sodium',
      'sulfur',
      // 'chlorine',
      'copper',
      'zinc',
      'manganese',
      'boron',
      'iron',
      'molybdenum'
  ];

  constructor(
      private recommendationManagerSharedDataService: RecommendationManagerSharedDataService
  ) {
      this.subscriptions = [
          this.recommendationManagerSharedDataService.recommendationDetailSubject.subscribe({
              next: res => {
                  this.recommendationDetails = res;
                  this.note = this.recommendationDetails?.recommendationNote;
                  this.comment = this.recommendationDetails?.comments;
              }
          }),
          this.recommendationManagerSharedDataService.recommendationSoftTissueSubject.subscribe({
              next: res => {
                  if(res?.content) {
                      this.sampleSource = new MatTableDataSource(res.content);
                      this.totalElements = res.totalElements;
                      this.nValues  = this.column(res.content, 'N');
                      this.pValues  = this.column(res.content, 'P');
                      this.kValues  = this.column(res.content, 'K');
                      this.caValues = this.column(res.content, 'Ca');
                      this.mgValues = this.column(res.content, 'Mg');
                      this.naValues = this.column(res.content, 'Na');
                      this.sValues  = this.column(res.content, 'S');
                      this.clValues = this.column(res.content, 'Cl');
                      this.cuValues = this.column(res.content, 'Cu');
                      this.znValues = this.column(res.content, 'Zn');
                      this.mnValues = this.column(res.content, 'Mn');
                      this.bValues  = this.column(res.content, 'B');
                      this.feValues = this.column(res.content, 'Fe');
                      this.moValues = this.column(res.content, 'Mo');
                  }
              }
          })
      ]
  }

  /**
   * One cell per table row for this element, in row order.
   *
   * The template reads these arrays by row index, so there has to be exactly one entry per row and
   * it has to be that row's own reading. This was built by pushing every key value into a flat
   * array and padding it by one per row, which only holds while each row carries each element
   * exactly once. It does not: a norm with a duplicated element made the API write two key values
   * per reading, so each row below the first read the row above it and the last read padding and
   * rendered as "-". Reported 28/10/2026 on recommendation 000001LI00065.
   *
   * Mapping per row cannot drift, whatever a row turns out to contain. The classified copy wins
   * where a row does carry more than one, so a duplicate with no level cannot take the colour off
   * a reading that has one.
   */
  private column(rows: any[], key: string): any[] {
      return (rows || []).map(row => {
          const matches = (row?.keyValues || []).filter((keyValue: any) => keyValue?.key === key);
          return matches.find((keyValue: any) => !!keyValue?.level) || matches[0] || {};
      });
  }

  emitChanges() {
      this.noteChangeEmit.emit({
          comment: this.comment,
          note: this.note
      });
  }

  ngOnInit() {

  }

  emitSearchChanges() {
      this.emitSearch.emit(this.searchText);
  }

    onPaginateChange(event: any) {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.emitPaginateChange.emit(event);
    }

    ngOnDestroy(): void {
      this.subscriptions.forEach(s => {
          s.unsubscribe();
      })
    }
}
